import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip, Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { CommonStyles } from '@kamernet/styles/CommonStyles';

import { ListingDetailsContext } from '../../ListingDetailsContext';

import styles from './AdditionalInfo.module.css';

export const AdditionalInfo = () => {
  const { listingDetails } = ListingDetailsContext.useContext();
  const { T } = useIntl();

  return listingDetails.wws_points ? (
    <section className={styles.root}>
      <Typography className={CommonStyles.margin_bottom_2} variant="h5">
        {T('label.additional_info')}
      </Typography>
      <div className={styles.rows}>
        <div className={styles.row}>
          <div className={styles.tooltip}>
            <Typography variant="body2" color="secondary.accent">
              {T('ldp.wws_label')}
            </Typography>
            <Tooltip
              color="secondary"
              enterDelay={0}
              title={
                <Typography
                  variant="body2"
                  dangerouslySetInnerHTML={{
                    __html: T('ldp.wws_info'),
                  }}
                />
              }
            >
              <InfoOutlinedIcon />
            </Tooltip>
          </div>
          <Typography variant="body2">{listingDetails.wws_points}</Typography>
        </div>
      </div>
    </section>
  ) : null;
};
